import React from 'react';
import { Error } from '../error/Error';
import { datadogRum } from '@datadog/browser-rum';

type Props = {
  onError?: (error: any) => void;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props | Readonly<Props>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    datadogRum.addError(error, undefined);
    if (process.env.REACT_APP_ENV !== 'prod') {
      console.error(error);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Error boundary />;
    }

    return this.props.children;
  }
}
